module.exports = __webpack_public_path__ + "img/4-8465.7adac58a.png";